import React from 'react';
import { TOAST_NOTIFICATION_TEMPLATES } from '../constants/toastNotificationTemplates';
import { NotificationMessage } from '../../shared/components/NotificationMessage';

/**
 * @typedef {object} CacheInvalidatingToastProps
 * @property {number} notificationType
 * @property {Object} notificationData
 * @property {(evictQuery: { __typename: string, Id: string | number }) => void} [clearCache]
 * @property {() => void} [closeToast]
 */

/**
 * @param {CacheInvalidatingToastProps} props
 */
export const CacheInvalidatingToast = props => {
  const { notificationType, notificationData, clearCache, closeToast } = props;
  const handleToastClick = () => {
    evictCacheOnToastClick(notificationType, notificationData, clearCache);
    closeToast();
  };

  return (
    <div onClick={handleToastClick}>
      <NotificationMessage
        notificationType={notificationType}
        notificationData={notificationData}
      />
    </div>
  );
};

const evictCacheOnToastClick = (type, data, clearCache) => {
  const template = TOAST_NOTIFICATION_TEMPLATES[type];

  if (template?.queryIdKey && template?.getEvictQuery) {
    const queryId = data[template.queryIdKey];
    const evictQuery = template.getEvictQuery(queryId);
    clearCache(evictQuery);
  }
};
